import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconOrthographic = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 1.4,
	clipRule: "evenodd",
	viewBox: "0 0 1024 1024",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M-102.573-102.74h1229.476v1229.476H-102.573z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 67.82,
			d: "m15356.5 319.324 298.5 298.543",
			transform: "matrix(1.20507 -.28459 .35608 1.18591 -18573.264 4207.581)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 67.82,
			d: "m15356.5 319.324 298.5 298.543",
			transform: "matrix(1.20507 -.28459 .35608 1.18591 -18573.264 4639.027)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 86.44752,
			d: "M512.137 907.405V485.11M184.237 727.239V295.563"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 67.82,
			d: "m15356.5 319.324 298.5 298.543",
			transform: "matrix(-1.20507 -.28459 -.35608 1.18591 19597.496 4207.581)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 67.82,
			d: "m15356.5 319.324 298.5 298.543",
			transform: "matrix(-1.20507 -.28459 -.35608 1.18591 19597.496 4639.027)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 86.44752,
			d: "M840.066 727.239V295.563"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 72,
			d: "m15488.9 310.74 314.7-314.709",
			transform: "matrix(.93887 .43828 -.08988 1.03223 -14325.771 -6813.589)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 72,
			d: "m15488.9 310.74 314.7-314.709",
			transform: "matrix(.09317 1.03412 -.94216 .43638 -636.026 -16045.584)"
		})
	]
});
export default SvgIconOrthographic;
